{
  "name": "@graphql/frontend",
  "version": "1.0.1",
  "scripts": {
    "start": "npx parcel ./src/index.html --watch-ignore node_modules",
    "start-11000": "parcel ./src/index.html --port 11000 --watch-ignore node_modules --no-scope-hoist",
    "build": "parcel build ./src/index.html",
    "build:docker": "docker build -t ghcr.io/stradivario/graphql-client:latest .",
    "lint": "npx eslint ./src --ext .ts",
    "lint-fix": "npx eslint ./src --fix --ext .ts",
    "test": "env $(cat .env | xargs) jest",
    "test:ci": "jest",
    "introspect": "gapi schema introspect --collect-documents --collect-types --with-compressed"
  },
  "author": "Kristiyan Tachev",
  "license": "MIT",
  "vaadin": {
    "disableUsageStatistics": true
  },
  "dependencies": {
    "@google-web-components/google-chart": "^4.0.1",
    "@octokit/core": "^3.1.2",
    "@reactive-redux/store": "6.3.11",
    "@revolut/checkout": "^1.0.8",
    "@rhtml/component": "^0.0.141",
    "@rhtml/components": "^0.0.141",
    "@rhtml/decorators": "^0.0.141",
    "@rhtml/di": "^0.0.141",
    "@rhtml/modifiers": "^0.0.141",
    "@rhtml/operators": "^0.0.141",
    "@rxdi/compressor": "^0.7.223",
    "@rxdi/core": "^0.7.223",
    "@rxdi/credit-card-form": "^0.7.223",
    "@rxdi/forms": "^0.7.223",
    "@rxdi/graphql-client": "^0.7.223",
    "@rxdi/hotkeys": "^0.7.223",
    "@rxdi/http": "^0.7.223",
    "@rxdi/lit-html": "^0.7.223",
    "@rxdi/router": "^0.7.223",
    "@rxdi/ui-components": "^0.7.37",
    "@rxdi/ui-kit": "^0.7.138",
    "@sentry/browser": "^7.37.2",
    "@shoelace-style/shoelace": "^2.0.0",
    "@stradivario/graphql-server": "0.0.11",
    "@stradivario/markdown": "0.0.14",
    "@stradivario/swiper": "0.0.8",
    "@vaadin/details": "^23.3.2",
    "@vaadin/icon": "^23.3.2",
    "@vaadin/icons": "^23.3.2",
    "@vaadin/multi-select-combo-box": "^23.3.2",
    "@vaadin/radio-group": "^23.3.2",
    "@vaadin/text-area": "^23.3.2",
    "@vaadin/vaadin-lumo-styles": "^23.3.2",
    "apollo-link-context": "^1.0.20",
    "apollo3-cache-persist": "^0.14.1",
    "braintree-web": "^3.74.0",
    "carbon-web-components": "^1.21.0",
    "codemirror": "^5.62.2",
    "diff": "^5.1.0",
    "droppable": "^2.2.0",
    "firebase": "7.14.6",
    "fuse.js": "^5.2.3",
    "graphql-tag": "^2.12.5",
    "hammerjs": "^2.0.8",
    "image-resize": "^1.3.2",
    "immer": "^4.0.0",
    "jest-environment-jsdom": "^29.3.1",
    "jsoneditor": "^10.4.2",
    "localforage": "^1.10.0",
    "mermaid": "^8.9.1",
    "parcel": "^2.16.3",
    "rambda": "^6.5.3",
    "rxjs": "^7.8.2",
    "shades": "^2.1.0",
    "svg-pan-zoom": "^3.6.1",
    "toastr": "^2.1.4",
    "ts-action": "^11.0.0",
    "ts-action-operators": "^9.1.2",
    "workbox-cacheable-response": "^6.5.4",
    "workbox-expiration": "^6.5.4",
    "workbox-precaching": "^6.5.4",
    "workbox-recipes": "^6.5.4",
    "workbox-routing": "^6.5.4",
    "workbox-strategies": "^6.5.4"
  },
  "browserslist": [
    "last 1 chrome versions"
  ],
  "devDependencies": {
    "@babel/core": "^7.10.2",
    "@parcel/packager-raw-url": "^2.16.3",
    "@parcel/transformer-webmanifest": "^2.16.3",
    "@types/braintree-web": "^3.69.3",
    "@types/codemirror": "^5.60.6",
    "@types/diff": "^5.0.2",
    "@types/hammerjs": "^2.0.41",
    "@types/jest": "^29.2.5",
    "@types/marked": "^1.2.1",
    "@types/mermaid": "^8.2.1",
    "@types/node": "^14.14.28",
    "@types/toastr": "^2.1.40",
    "@typescript-eslint/eslint-plugin": "^5.53.0",
    "@typescript-eslint/parser": "^5.53.0",
    "assert": "^2.1.0",
    "babel-plugin-module-resolver": "^5.0.2",
    "cssnano": "^4.1.10",
    "eslint": "^8.31.0",
    "eslint-config-prettier": "^8.6.0",
    "eslint-plugin-lit": "^1.8.2",
    "eslint-plugin-prettier": "^4.2.1",
    "eslint-plugin-simple-import-sort": "^10.0.0",
    "graphql": "^14.6.0",
    "gts": "^3.1.1",
    "husky": "^4.2.1",
    "jest": "29.3.1",
    "jest-cli": "29.3.1",
    "jest-environment-jsdom-sixteen": "^2.0.0",
    "prettier": "^2.8.4",
    "process": "^0.11.10",
    "ts-jest": "^29.0.3",
    "ts-loader": "^9.4.2",
    "ts-toolbelt": "^9.6.0",
    "typescript": "^4.9.4",
    "util": "^0.12.5"
  },
  "engines": {
    "npm": ">=10",
    "node": ">=20"
  },
  "husky": {
    "hooks": {
      "pre-commit": "npm run lint-fix"
    }
  }
}
